var ezdia;
(function (ezdia) {
    var NAME = 'category';
    var TYPE = 'category';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var wrapperID = 'ez-ui-category-dialog-wrapper';
    var listIDPrefix = 'ez-ui-category-list-';
    var boxIDPrefix = listIDPrefix + "box-";
    var searchIDPrefix = listIDPrefix + "search-";
    var boxSelecter = 'div[data-row="box"]';
    var parentLinkSelecter = 'a[data-row="select"]';
    var DEFAULT = {
        value: null,
        limit: 20,
        height: 500,
        width: '100%',
        minBoxWidth: 250,
        title: null,
        selectClass: 'selected',
        filterText: 'div[data-row=text]',
        optionTemplate: ezdia.templates.category.typeaheadOptions,
        listTemplate: ezdia.templates.category.mainTemplate
    };
    var Category = /** @class */ (function () {
        function Category(elem, options) {
            this.elem = elem;
            this.init(options);
        }
        Object.defineProperty(Category.prototype, "Defaults", {
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        Category.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        Category.prototype.getHiddenElement = function () {
            var column = this.options.column;
            var id = (column.id || column.name) + "-date-value";
            return $("#" + id);
        };
        Category.prototype.init = function (options) {
            this.name = this.elem.name;
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.$hiddenElem = this.getHiddenElement();
            this.ajaxData = {};
            this.boxCount = 0;
            this.render();
        };
        Category.prototype.render = function () {
            this.config = this.options.column.config || {};
            this.wrapper = $.ezdia.getWrapper(wrapperID);
            this.setLabel();
            this.typeahead();
            this.createBrowseCategory();
        };
        Category.prototype.showCategorys = function () {
            this.reset();
            this.createCategoryList('root');
            this.openDialog();
            this.setWidth();
            if (this.elem.value) {
                this.creategetHierarchy();
            }
        };
        Category.prototype.setLabel = function () {
            var metaInfo = $.ezdia.config.metaObj || {};
            var catObj = metaInfo.category;
            var value = '';
            if (this.elem.value && catObj) {
                value = catObj.name || this.values;
                this.$elem.val(value);
            }
        };
        Category.prototype.typeahead = function () {
            var source = this.getBloodhoundObj();
            var hiddenId = this.$hiddenElem;
            var id = this.$elem;
            var placeholder = this.options.column.placeholder || '';
            id.typeahead({
                hint: true,
                highlight: true,
                minLength: 3
            }, {
                name: 'source',
                displayKey: 'label',
                source: source.ttAdapter(),
                templates: {
                    suggestion: this.options.optionTemplate,
                    notFound: '<div class="tt-empty">Search query not found.</div>'
                }
            })
                .on('click', function click() {
                var ev = $.Event('keydown');
                ev.keyCode = 40;
                ev.which = 40;
                $(this).trigger(ev);
                return true;
            })
                .on('typeahead:selected', function typeahead(object, datum) {
                $(this).trigger('typeahead:_done', [object, datum]);
            })
                .on('typeahead:autocompleted', function typeahead(object, datum) {
                $(this).trigger('typeahead:_done', [object, datum]);
            })
                .on('change', function change() {
                $(this).trigger('typeahead:_changed');
            })
                .on('typeahead:_changed', function () {
                var label = id.data('label');
                var value = id.typeahead('val');
                var doneActive = id.data('_done');
                if (value && label !== value && !doneActive) {
                    id.typeahead('val', label);
                }
                id.typeahead('close');
            })
                .on('typeahead:_done', function (evt, object, datum) {
                id.data('_done', true);
                id.typeahead('close').blur();
                hiddenId.val(datum.value || '').trigger('change');
                id.data('_done', false);
            });
            placeholder = placeholder || id.attr('placeholder');
            id.on('focus', function () {
                var label = id.typeahead('val');
                id.data('label', label);
                id.select();
                id.removeAttr('placeholder');
            }).on('blur', function () {
                id.attr('placeholder', placeholder);
            });
        };
        Category.prototype.getBloodhoundObj = function () {
            var self = this;
            var url = this.config.url || 'fetchCategoryHierarchy.htm?term=';
            var bloodhoundObj = {
                datumTokenizer: Bloodhound.tokenizers.obj.whitespace('label'),
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                limit: this.config.limit || this.options.limit,
                remote: {
                    url: url,
                    replace: function (qurl, query) {
                        self.srcQuery = query;
                        return qurl + encodeURIComponent(query);
                    },
                    ajax: {
                        type: 'POST',
                        dataType: 'json'
                    },
                    filter: function (list) {
                        return $.map(list, function (obj) { return self.formatData(obj); });
                    }
                }
            };
            var source = new Bloodhound(bloodhoundObj);
            source.initialize();
            return source;
        };
        Category.prototype.formatData = function (obj) {
            var arr = $.ezdia.getJsonObject(obj.category_mapping);
            var label = '';
            var value = '';
            var display = '';
            this.options.limit = arr.length;
            $.each(arr, function (i, eObj) {
                var key = Object.keys(eObj)[0];
                display += display ? ' <i class="fa fa-angle-right"></i> ' : '';
                display += key;
                label = key;
                value = eObj[key];
            });
            return {
                label: label,
                value: value,
                display: display,
                srcKey: this.srcQuery
            };
        };
        //
        // ===================
        Category.prototype.createBrowseCategory = function () {
            var id = "ez-sys-browse-category-" + this.name;
            this.$elem.after("<a href=\"javascript:void(0);\" class=\"small mr-b-xs\" id=\"" + id + "\">Browse category</a>");
            $("#" + id).on("click." + TYPE, $.proxy(this.showCategorys, this));
        };
        Category.prototype.openDialog = function () {
            var self = this;
            var options = this.options;
            var title = options.title || options.column.label;
            this.dialog = this.wrapper.dialog({
                modal: true,
                title: title,
                width: options.width,
                height: options.height,
                buttons: [
                    {
                        text: 'Cancel',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Select',
                        click: function () {
                            self.addValue();
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        };
        Category.prototype.getCategoryList = function (query) {
            var dataObj = this.ajaxData[query];
            if (!dataObj) {
                dataObj = getCategoryListReq.call(this, query);
            }
            return dataObj;
        };
        Category.prototype.createCategoryList = function (query) {
            var count = this.boxCount;
            var action = query === 'root' ? 'html' : 'append';
            var list = this.getCategoryList(query);
            var pos = this.getPos();
            var context = {
                boxID: boxIDPrefix + count,
                listID: listIDPrefix + count,
                searchID: searchIDPrefix + count,
                list: list,
                pos: pos
            };
            var content = this.options.listTemplate(context);
            this.wrapper[action](content);
            // eslint-disable-next-line no-plusplus
            ++this.boxCount;
            this.listAction(context);
            if (!this.resetBox) {
                this.setFocus();
            }
        };
        Category.prototype.listAction = function (obj) {
            var self = this;
            var options = this.options;
            var item = "li[data-value]:not(." + options.selectClass + ")";
            $("#" + obj.listID).sortItems({
                items: '[data-search]',
                child: options.filterText
            });
            $("#" + obj.listID)
                .off("click." + TYPE)
                .on("click." + TYPE, item, function click() {
                self.itemSelect(this);
            })
                .on("click." + TYPE, parentLinkSelecter, function click(e) {
                e.stopPropagation();
                self.selectParentValue(this);
            })
                .find('[data-leaf="leaf"]')
                .off('dblclick')
                .on('dblclick', function dblclick() {
                self.itemSelect(this);
                self.addValue();
                self.dialog.dialog('close');
            });
            $("#" + obj.searchID).filterSearch({
                child: options.filterText
            });
        };
        Category.prototype.itemSelect = function (element) {
            var elem = $(element);
            var query = elem.data('value');
            var text = elem.data('label');
            var leaf = !!elem.data('leaf');
            this.clearListBox(elem);
            this.toggleSiblings(elem);
            if (!leaf) {
                this.createCategoryList(query);
            }
            else {
                this.selectedLeaf = {
                    text: text,
                    id: query
                };
            }
        };
        Category.prototype.selectParentValue = function (element) {
            var elem = $(element);
            var query = elem.data('value');
            var text = elem.data('label');
            this.selectedLeaf = {
                text: text,
                id: query
            };
            this.addValue();
            this.dialog.dialog('close');
        };
        Category.prototype.creategetHierarchy = function () {
            var hierarchy = getCategoryHierarchy.call(this);
            $.each(hierarchy, function (i, obj) {
                var elem = $("#" + listIDPrefix + i).find("li[data-value=" + obj.ezCategoryId + "]");
                if (elem.length) {
                    elem.trigger('click');
                }
            });
        };
        Category.prototype.addValue = function () {
            if (!this.selectedLeaf) {
                return;
            }
            var obj = this.selectedLeaf;
            var val = obj.text.trim();
            this.$elem.val(val);
            this.$hiddenElem.val(obj.id).trigger('change');
            this.$elem.typeahead('val', val);
            this.values = obj.id;
        };
        Category.prototype.toggleSiblings = function (elem) {
            var options = this.options;
            var cls = options.selectClass;
            elem.addClass(cls).siblings().removeClass(cls);
        };
        Category.prototype.clearListBox = function (elem) {
            var parentBox = elem.closest(boxSelecter);
            var boxs = parentBox.nextAll(boxSelecter);
            var count = boxs.length;
            boxs.remove();
            this.boxCount -= count;
        };
        Category.prototype.getPos = function () {
            var count = this.boxCount;
            var minCount = count - 1;
            var widths = 0;
            var minWidth = 0;
            var minBoxWidth = true;
            var pos = {};
            var suffix = '%';
            if (count && minCount) {
                count += 1;
                minWidth = this.totalWidth / count;
                minBoxWidth = minWidth >= this.options.minBoxWidth;
            }
            if (!count) {
                pos = {
                    width: '50%',
                    left: 0
                };
            }
            else if (!minCount) {
                this.resetBox = true;
                this.setBoxsStyles(50, suffix);
                pos = {
                    width: '50%',
                    left: '50%'
                };
            }
            else {
                if (minBoxWidth) {
                    widths = 100 / count;
                    this.resetBox = true;
                }
                else {
                    widths = this.options.minBoxWidth;
                    suffix = 'px';
                }
                if (this.resetBox) {
                    this.setBoxsStyles(widths, suffix);
                }
                pos = {
                    width: widths + suffix,
                    left: widths * (count - 1) + suffix
                };
            }
            return pos;
        };
        Category.prototype.setBoxsStyles = function (widths, suffix) {
            var boxs = this.wrapper.find('[data-row="box"]');
            $.each(boxs, function eachbox(i) {
                var left = widths * i + suffix;
                $(this).css({
                    left: left,
                    width: widths + suffix
                });
            });
            if (suffix === 'px') {
                this.resetBox = false;
            }
        };
        Category.prototype.setFocus = function () {
            var count = this.boxCount - 1;
            var box = $("#" + boxIDPrefix + count);
            var left = box.position().left;
            left += box.outerWidth();
            if (this.totalWidth <= left) {
                this.wrapper.scrollLeft(left);
            }
        };
        Category.prototype.setWidth = function () {
            var widths = $("#" + boxIDPrefix + 0).outerWidth();
            this.totalWidth = widths * 2;
        };
        Category.prototype.reset = function () {
            this.boxCount = 0;
            this.resetBox = true;
        };
        return Category;
    }());
    // AJAX FUNCTIONS
    // =========================
    var getCategoryListReq = function (query) {
        var responseObj = {};
        $.ajax({
            type: 'POST',
            url: "fetchcategories.htm?parentCategory=" + query,
            dataType: 'json',
            async: false,
            success: function (response) {
                responseObj = response;
            },
            error: function () {
                responseObj = '';
            }
        });
        return responseObj;
    };
    function getCategoryHierarchy() {
        var responseObj = {};
        var query = this.$hiddenElem.val();
        $.ajax({
            type: 'POST',
            url: "getcategoryhierarchy.htm?childCategory=" + query,
            dataType: 'json',
            async: false,
            success: function (response) {
                responseObj = response;
            },
            error: function () {
                responseObj = '';
            }
        });
        return responseObj;
    }
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
    // getValue: Category.prototype.getValue,
    // refresh: Category.prototype.refresh,
    // destroy: Category.prototype.destroy
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof Category) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new Category(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = Category;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
